import type { ImgHTMLAttributes } from "react";

export type SocialBrandChannel = "instagram" | "facebook" | "whatsapp";

const socialBrandAssets: Record<SocialBrandChannel, string> = {
  instagram: `${import.meta.env.BASE_URL}assets/integrations/instagram-glyph-gradient-official.png`,
  facebook: `${import.meta.env.BASE_URL}assets/integrations/facebook-logo-primary-official.png`,
  whatsapp: `${import.meta.env.BASE_URL}assets/integrations/whatsapp-glyph-green-official.svg`,
};

interface SocialBrandMarkProps extends Omit<ImgHTMLAttributes<HTMLImageElement>, "src"> {
  channel: SocialBrandChannel;
}

export function SocialBrandMark({ channel, alt = "", ...props }: SocialBrandMarkProps) {
  return (
    <img
      {...props}
      src={socialBrandAssets[channel]}
      alt={alt}
      decoding="async"
      draggable={false}
      data-social-brand={channel}
    />
  );
}
